export default __webpack_public_path__ + "static/media/6.ef324148.gif";